import { Component, OnInit } from '@angular/core';
import { Location } from "@angular/common";
import { Router, ActivatedRoute } from "@angular/router";

import { FireDataService } from '../fire-data.service';

import { CaseType } from '../case-type';
import { CASES } from '../case-list';

@Component({
  selector: 'app-case-daily-activity',
  templateUrl: './case-daily-activity.component.html',
  styleUrls: ['./case-daily-activity.component.css']
})
export class CaseDailyActivityComponent implements OnInit {

cases = []
selectedCase: CaseType;

  constructor(private fds: FireDataService, private router: Router, private route: ActivatedRoute, private location: Location) { 

      //this.isLogged();
  }

  ngOnInit() { 
    for (var i in CASES) {
     if (!CASES[i]['hidden']) {this.cases.push(CASES[i])}
    }
  }

  onSelect(case1: CaseType): void {
      this.selectedCase = case1;
      this.router.navigate(['/case-master', this.selectedCase.id]);
  }

  private isLogged() {
    this.fds.user.subscribe(res => {
      if (res) {
        return
      }
      if (!res) {
        this.router.navigate(["/login"]);
      }
    });
  }

  public goBack() {
    this.location.back();

  }


}



// WEBPACK FOOTER //
// c:/Dev/Angular/liceo/src/app/case-daily-activity/case-daily-activity.component.ts